import { styled } from '@mui/material/styles'
import { alpha, Box } from '@mui/material'

export const ExpandContainer = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 24,
  left: 24,
  display: 'flex',
  flexDirection: 'column',
  zIndex: 10
}))

export const ExpandIcon = styled(Box)(({ theme }) => ({
  color: '#464646',
  cursor: 'pointer',
  backgroundColor: 'white',
  minHeight: '30px',
  minWidth: '30px',
  maxHeight: '30px',
  maxWidth: '30px',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: `0 12px 16px -8px ${alpha(
    theme.palette.common.black,
    0.24,
  )}`,
  '&:hover': {
    color: theme.palette.primary.main,
  },
}))
